import type { FC } from 'react';
import React, { useCallback, useMemo } from 'react';
import '@/assets/styles/ui-component.less';
import { Carousel } from '@/basic/ReoCarousel';
import type { IBanner, IProps } from './IComponent';
import classNames from 'classnames';
import CommonBox from '@/basic/CommonBox/CommonBox';
import BannerItem from './components/BannerItem';
import { ReoIcon } from '@reolink-web/ui';
import useScreenWidthByUA from '@/utils/hooks/useScreenWidthByUA';
import './index.less';
import { ReoCarousel } from '@/deps/basic';
import * as utils from '@reolink-web/utils';

const OwlBanner: FC<IProps> = (props) => {

    const { bannerConfig, ctx } = props;

    const screenWidth = useScreenWidthByUA(ctx?.headers?.userAgent);

    const jumpTo = useCallback((url: string) => {
        // if (self !== top) return;
        if (url) {
            location.href = url;
        }

    }, []);

    const currentSetting = useCallback((banner: IBanner) => {
        if (screenWidth >= 768) {
            return banner.setting.pc;
        }
        else {
            if (banner.setting.mobileIsSame) {
                return banner.setting.pc;
            }
            else {
                return banner.setting.mobile;
            }
        }
    }, [screenWidth]);
    // 是否展示左右箭头和下放的点击切换按钮
    const showArrows = useMemo(() => {
        return screenWidth >= 1280 && bannerConfig.length > 1;
    }, [bannerConfig.length, screenWidth]);

    const renderArrowPrev = (onClickHandler: () => void): React.ReactElement | null => {
        return (
            screenWidth > 1280 ? (
                <div
                    className={ 'store-banner-arrow store-banner-arrow-prev' }
                    onClick={ onClickHandler }
                >
                    <ReoIcon
                        name={ 'icon-new-arrow-left' }
                        hoverColor='var(--b_6)'
                        color='#ffffff'
                        width={ 25 }
                        className='store-arrow-icon'
                    >
                    </ReoIcon>
                </div>
            ) : null
        );
    };
    const renderArrowNext = (onClickHandler: () => void): React.ReactElement | null => {
        return (
            screenWidth > 1280 ? (
                <div
                    className={ 'store-banner-arrow store-banner-arrow-next' }
                    onClick={ onClickHandler }
                >
                    <ReoIcon
                        name={ 'icon-new-arrow-right' }
                        hoverColor='var(--b_6)'
                        color='#ffffff'
                        width={ 25 }
                        className='store-arrow-icon'
                    >
                    </ReoIcon>
                </div>
            ) : null
        );
    };

    const mobileCarouselItems = useMemo(() => {
        return bannerConfig?.map(item => {
            return {
                key: utils.String.randomString(6),
                content: (
                    <BannerItem
                        data={ item }
                        screenWidth={ screenWidth }
                        key={ item.meta.title }
                    />
                )
            };
        });
    }, [bannerConfig, screenWidth]);

    if (bannerConfig.length == 0) {
        return null;
    }

    return (
        <CommonBox style={ props.style }>
            <div className={ classNames('store_banner') }>
                {
                    screenWidth >= 768 ? (
                        <Carousel
                            showArrows={ showArrows }
                            // autoPlay={true}
                            isHoverArrow={ false }
                            stopOnHover={ true }
                            infiniteLoop={ true }
                            showIndicators={ bannerConfig.length > 1 }
                            swipeable={ true }
                            showThumbs={ false }
                            centerMode={ false }
                            renderArrowPrev={ renderArrowPrev }
                            renderArrowNext={ renderArrowNext }
                            onClickItem={ (args) => { jumpTo((currentSetting(bannerConfig[args]).link)); } }
                            indicatorClassName={ 'banner_dot' }
                        >
                            {
                                bannerConfig.map(function(item) {
                                    return (
                                        <BannerItem
                                            data={ item }
                                            screenWidth={ screenWidth }
                                            key={ item.meta.title }
                                        />
                                    );
                                })
                            }
                        </Carousel>
                    ) : (
                        <ReoCarousel
                            hasController={ false }
                            draggable={ true }
                            slidesPerView={ 'auto' }
                            items={ mobileCarouselItems }
                            className={ 'owl_banner_m_carousel' }
                            loop={ true }
                            spaceBetween={ 0 }
                            effect={ 'slide' }
                            hasPagination={ true }
                            autoplay={ true }
                            interval={ 2000 }
                        />
                    )
                }

            </div>
        </CommonBox>
    );
};

export default OwlBanner;
